import { SourcingService } from 'api-clients/monolith';

import { QueryParams } from '@/hooks/use-filter-query';

export function getBrands(params: QueryParams) {
  return SourcingService.getInternalApiSourcingBrands(
    params.page,
    params.perPage,
    params.query,
    params.isSelectedForSourcing,
  );
}
